export interface CaseProject {
  id: number;
  title: string;
  description: string;
  imageSrc: string;
  logo?: {
    src: string;
    marginTop: number;
  };
  // Detailed content for case details page
  category: string;
  date: string;
  author: string;
  heroImage: string;
  content: {
    paragraphs: {
      title?: string;
      content: string;
    }[];
    images: {
      src: string;
      caption?: string;
    }[];
  };
}

export interface CasesHeadlineData {
  title: string;
  subtitle: string;
}

export interface CasesContent {
  headline: CasesHeadlineData;
  caseProjects: CaseProject[];
}

// PER LOGO TE ALORES

// logo: {
//   src: "/project-logos/alora.jpeg",
//   marginTop: 25,
// },

export const CASES_CONTENT: CasesContent = {
  headline: {
    title: "Cases",
    subtitle:
      "Explore our portfolio of successful projects where we've helped businesses transform their digital presence and capabilities.",
  },
  caseProjects: [
    // {
    //   id: 7,
    //   title:
    //     "Floovle: Global Platform Revolutionizing Aesthetic Surgery with AI & Mapping",
    //   description:
    //     "Floovle transforms aesthetic healthcare with AI, interactive maps, and serverless tech—empowering global patients with trusted access to licensed providers.",
    //   imageSrc: "/projects-pictures/floovleHero.png",
    //   category: "MEDICAL TECH",
    //   date: "07.28.2025",
    //   author: "Adonis Shabani",
    //   heroImage: "/projects-pictures/floovleHero.png",
    //   logo: {
    //     src: "/project-logos/floovle.svg",
    //     marginTop: 20,
    //   },
    //   content: {
    //     paragraphs: [
    //       {
    //         title:
    //           "The Vision: Democratizing Aesthetic Surgery Access Globally",
    //         content:
    //           "The aesthetic surgery industry needed a transformation. Patients faced fragmented, untrustworthy resources, making it difficult to research procedures, find credible professionals, and confidently book care—especially across borders. Inspired by how Airbnb disrupted hospitality, Floovle set out to become the go-to global platform for aesthetic procedures—empowering patients and elevating healthcare provider visibility.",
    //       },
    //       {
    //         title: "The Challenge: A Broken Ecosystem",
    //         content:
    //           "There was no centralized hub connecting patients with licensed, vetted providers on a global scale. Misinformation, lack of verified data, and opaque booking systems created friction and anxiety for users seeking cosmetic treatments—especially those looking abroad. The goal: build a transparent, scalable, AI-enhanced solution to unify this industry.",
    //       },
    //       {
    //         title: "AI-Powered Assistance That Understands Context",
    //         content:
    //           "We created a context-aware AI chatbot using OpenAI’s embedding models paired with PostgreSQL vector storage. Users can upload documents like clinic brochures or personal medical notes. These are instantly parsed, embedded, and referenced in real time, giving patients highly contextual responses via a WebSocket-based GPT-4 chat interface.",
    //       },
    //       {
    //         title: "Interactive Mapping System for Global Discovery",
    //         content:
    //           "To enable location-based discovery of aesthetic providers, we engineered a dynamic, filterable map experience with Google Maps API and PostGIS. Real-time clustering, region-based caching, and geospatial queries allow users to browse providers by specialty, country, or certification—seamlessly.",
    //       },
    //       {
    //         title: "A Serverless Infrastructure Built to Scale",
    //         content:
    //           "Using AWS Lambda, API Gateway, and RDS PostgreSQL, we deployed a robust, cost-effective backend infrastructure. Optimized for performance and scale, the architecture supports global user demand with low-latency database access, connection pooling, and cold-start resilience.",
    //       },
    //       {
    //         title: "Frontend Engineering for Speed and Engagement",
    //         content:
    //           "The frontend is a SPA built with React, TypeScript, and Ant Design. React Query handles server-state and caching, while WebSocket integrations provide real-time updates. A modular, fully-tested component library ensures scalability and consistency across the app.",
    //       },
    //       {
    //         title: "Real-Time Features That Empower Users",
    //         content:
    //           "From instant AI responses to live geolocation updates and seamless booking experiences, Floovle delivers real-time value. Whether users are browsing on mobile or desktop, every interaction is fast, intuitive, and secure.",
    //       },
    //       {
    //         title: "The Results: A Transparent Ecosystem for Global Care",
    //         content:
    //           "Floovle is now empowering patients worldwide with clarity, confidence, and access. Providers benefit from increased visibility and global reach. This isn’t just a booking site—it’s a living, AI-driven ecosystem educating and connecting people across the world.",
    //       },
    //       {
    //         title: "Why Floovle’s Model Sets a New Standard",
    //         content:
    //           "By combining AI, serverless architecture, and location intelligence, Floovle offers unmatched scalability and user trust. It shows how tech can humanize care, reduce friction, and reshape a fragmented industry into a trusted global network.",
    //       },
    //       {
    //         title: "Conclusion: Building the Future of Medical Travel",
    //         content:
    //           "Floovle proves that personalized AI, scalable infrastructure, and thoughtful UX can redefine an entire sector. The platform is not only transforming how aesthetic surgery is accessed—it’s setting the blueprint for future digital health solutions.",
    //       },
    //     ],
    //     images: [
    //       {
    //         src: "/projects-pictures/floovle1.png",
    //         caption: "AI Chatbot with Document Upload & Real-Time Responses",
    //       },
    //       {
    //         src: "/projects-pictures/floovle2.png",
    //         caption: "Interactive Global Map with Geolocation-Based Filtering",
    //       },
    //     ],
    //   },
    // },
    {
      id: 3,
      title:
        "Damar‑Studios.com: Immersive 3D Experience with React, TypeScript & Three.js",
      description:
        "A cinematic, interactive portfolio site for Damar Studios—powered by React-Three-Fiber, a custom CMS, and 3D storytelling that captures their creative vision and elevates user engagement.",
      imageSrc: "/projects-pictures/damarHero.png",
      logo: {
        src: "/project-logos/damar-logo.svg",
        marginTop: 100,
      },
      category: "CREATIVE WEB EXPERIENCE",
      date: "07.23.2025",
      author: "Arnit Gashi",
      heroImage: "/projects-pictures/damarHero.png",
      content: {
        paragraphs: [
          {
            title: "The Vision: Bring Creativity to Life Through Motion",
            content:
              "Damar Studios needed more than a website—they needed an immersive digital experience that reflected their bold, design-forward approach. Their old site lacked the motion, interactivity, and depth needed to match their brand. Our challenge: craft a 3D, scroll-based portfolio site with full CMS control over content, animations, and assets.",
          },
          {
            title: "The Build: React + Three.js + Custom CMS",
            content:
              "We built the frontend using React, TypeScript, and React-Three-Fiber (Three.js for React) to enable cinematic animations, 3D scene transitions, and scroll-based storytelling. Hover effects, camera panning, and frame-by-frame animations powered by useFrame hooks created a dynamic feel. On the backend, we developed a Node.js + MongoDB CMS that lets Damar's team manage models, animations, and content—no developer needed.",
          },
          {
            title:
              "The Result: A Digital Showcase That Performs Like Their Work",
            content:
              "Since launch, Damar Studios saw increased engagement and portfolio interaction. Visitors now explore the site like a digital stage, not a brochure. The custom CMS enables internal control, while the tech stack ensures scalability for future 3D, AR, or VR expansions. This isn't just a site—it's an experience that proves the agency's creativity from the first click.",
          },
        ],
        images: [
          {
            src: "/projects-pictures/damar1.png",
            caption:
              "Damar Studios - 3D Interactive Homepage Powered by React-Three-Fiber",
          },
          {
            src: "/projects-pictures/damar2.png",
            caption:
              "CMS-Controlled Scene Transitions and Dynamic Portfolio Assets",
          },
        ],
      },
    },
    {
      id: 6,
      title:
        "How Alora Turned a Basic Food Delivery App into a Scalable Business with Soloop",
      description:
        "Soloop helped Alora transform a struggling MVP into a scalable food delivery platform for local restaurants across Germany—stabilizing performance, refactoring code, and adding new features for long-term growth.",
      imageSrc: "/projects-pictures/aloraHero.png",
      category: "MOBILE & WEB APP",
      date: "07.23.2025",
      author: "Arnit Gashi",
      heroImage: "/projects-pictures/aloraHero.png",
      logo: {
        src: "/project-logos/alore.jpeg",
        marginTop: 90,
      },
      content: {
        paragraphs: [
          {
            title: "Introduction: From a Prototype to a Powerhouse",
            content:
              "Every successful app begins with a small vision that grows faster than expected. Alora, a German food delivery startup, wanted to connect local restaurants with nearby customers through a mobile-first experience. The idea was strong, but the technology struggled to keep up. As more users and restaurants joined, bugs, timeouts, and architectural limits started slowing things down. Alora had a working prototype, but it lacked the stability and scalability needed for growth. That was when they partnered with Soloop, a technical team that helps startups evolve from early MVPs into reliable, scalable businesses.",
          },
          {
            title: "Understanding Alora: A Local Food Delivery Vision",
            content:
              "Alora was created for small and medium-sized restaurants in Germany. Unlike global competitors, it focused on local delivery networks and community-based dining experiences.",
          },
          {
            title: "The German Food Delivery Landscape",
            content:
              "Germany's delivery market is highly competitive, with large players like Wolt and Lieferando dominating major cities. However, smaller towns often lacked affordable and customizable solutions. Alora saw this gap and aimed to fill it with localized technology.",
          },
          {
            title: "Why Alora Focused on Small Cities and Local Restaurants",
            content:
              "By prioritizing small cities, Alora built stronger relationships with restaurant owners who preferred personalized support over corporate partnerships. This strategy helped them gain an early customer base, but it also made scaling technically challenging.",
          },
          {
            title: "The Challenge: From MVP to Market-Ready",
            content:
              "When Alora approached Soloop, the app was live and functional. It had users, restaurants, and traction. However, the platform faced several critical problems: the architecture was not scalable, leading to performance bottlenecks; API calls were inconsistent, causing order delays and timeouts; legacy PHP and Java code was difficult to maintain; and there was no structured roadmap or maintenance process. In short, Alora had a functional MVP, but it was not ready for market growth. They needed structure, speed, and a partner who could help them evolve into a dependable platform.",
          },
          {
            title: "The Solution: Soloop Steps In",
            content:
              "Soloop became more than just a development agency. They acted as a technical cofounder, providing deep architectural support and long-term guidance. Their approach was simple yet effective: clean up the existing system, expand its capabilities, and prepare it for scale.",
          },
          {
            title: "Phase 1: Cleaning Up the Codebase",
            content:
              "Soloop began by refactoring and stabilizing the existing code. Their engineers restructured backend logic, improved performance, and reduced bugs that caused customer frustration.",
          },
          {
            title: "Stabilizing PHP, Java, and Node.js Modules",
            content:
              "Soloop cleaned and reorganized PHP code for better modularity, improved Java services for backend reliability, optimized Node.js APIs to minimize latency and prevent timeouts, and created better communication between frontend and backend to enhance the user experience. This phase improved system stability and significantly reduced errors during peak usage hours.",
          },
          {
            title: "Phase 2: Powering Up with New Features",
            content:
              "Once the foundation was stable, Soloop added new capabilities to make Alora more functional and user-friendly.",
          },
          {
            title: "Vendor-Side Control Panel and Real-Time Tracking",
            content:
              "Restaurants gained direct control over incoming orders, delivery windows, and preparation times. Customers could also track their food in real time from the kitchen to their doorstep.",
          },
          {
            title: "Localized Enhancements for German Users",
            content:
              "To improve adoption, Soloop added German language support, regional address validation, and local tax and invoice handling aligned with German regulations. These updates helped Alora connect more effectively with local users and restaurants.",
          },
          {
            title: "Phase 3: Building for the Long Term",
            content:
              "Soloop did not stop after the product was fixed. They also set up systems for continuous growth and maintenance. Their team implemented version control for smoother updates, automated testing flows to catch bugs early, and bug tracking systems for quick response and monitoring. These steps created a predictable development cycle and made the platform easier to scale in the future.",
          },
          {
            title: "Lessons Learned from Alora's Transformation",
            content:
              "Alora's journey offers valuable insights for other startups struggling to scale their MVPs: Code quality matters from day one—refactoring early can save months of future technical debt. Localization drives adoption—meeting regional needs can set your product apart from competitors. Maintenance is an investment, not an expense—a structured maintenance process prevents chaos.",
          },
          {
            title: "From Reacting to Scaling: The Soloop Mindset",
            content:
              "Soloop helped Alora shift its mindset from fixing problems to building strategically. This change allowed them to grow with confidence, supported by a solid technical foundation and a clear roadmap.",
          },
          {
            title: "What This Means for You",
            content:
              "If your product is already live but struggling to scale, Alora's story might sound familiar. You do not always need a full rebuild. Sometimes, you just need a partner who understands how to turn existing technology into a growth engine. Soloop specializes in helping startups and growing businesses optimize their existing products—improving speed, cleaning up code, and managing long-term maintenance with structure for consistent growth.",
          },
        ],
        images: [],
      },
    },
    {
      id: 1,
      title:
        "VMaintenance: Smarter Fleet Management with Predictive AI Built-In",
      description:
        "A modern fleet management platform with built-in predictive AI, enabling vehicle managers to reduce downtime, automate reminders, track performance, and prevent costly repairs through intelligent forecasting.",
      imageSrc: "/projects-pictures/vMaintenanceHero.jpg",
      category: "WEB APP",
      date: "07.23.2025",
      author: "Arnit Gashi",
      heroImage: "/projects-pictures/vMaintenanceHero.jpg",
      content: {
        paragraphs: [
          {
            title: "The Challenge: Reactive Fleet Management",
            content:
              "VMaintenance was created to solve a common operational headache: inefficient, reactive fleet management. Whether a company owns a handful of vans or manages hundreds of delivery trucks, the challenges are the same—missed deadlines, costly repairs, and chaotic vehicle records.",
          },
          {
            title: "Centralized System Solution",
            content:
              "With VMaintenance, we built a centralized system that streamlines operations. Companies can manage multiple branches, track vehicles with full service history, assign users with role-based access, and receive intelligent, AI-driven alerts based on real usage data.",
          },
          {
            title: "Comprehensive Tracking Features",
            content:
              "The platform supports automated and manual mileage logging, structured deadline tracking for maintenance and compliance, and keeps archival data for sold or retired vehicles—ensuring everything is audit-ready and transparent.",
          },
          {
            title: "AI-Powered Predictions",
            content:
              "The standout feature is VMaintenance's predictive AI engine. It analyzes vehicle patterns, compares service intervals across fleets, and recommends actions before issues arise—transforming a reactive repair model into a proactive strategy.",
          },
          {
            title: "Proven Results",
            content:
              "Since launch, early adopters have reported fewer breakdowns, improved compliance, and significant time savings on administrative work—all while gaining confidence and control over their fleet operations.",
          },
        ],
        images: [
          {
            src: "/projects-pictures/vMaintenance1.png",
            caption: "VMaintenance - Fleet Management Dashboard Overview",
          },
          {
            src: "/projects-pictures/vMaintenance2.png",
            caption: "VMaintenance - AI-Driven Predictive Analytics Interface",
          },
        ],
      },
    },
    {
      id: 2,
      title:
        "Premium Online Store with WordPress & Custom Theme: Scaling Luxury Ecommerce with Purpose",
      description:
        "For luxury distributors like Twelve-KS, a custom-built WordPress + WooCommerce store enables brand-level storytelling, seamless mobile UX, and marketing control—all without compromising performance or scalability.",
      imageSrc: "/projects-pictures/twelveHero.jpg",
      logo: {
        src: "/project-logos/twelve.png",
        marginTop: 20,
      },
      category: "E-COMMERCE",
      date: "07.23.2025",
      author: "Arnit Gashi",
      heroImage: "/projects-pictures/twelveHero.jpg",
      content: {
        paragraphs: [
          {
            title: "The Challenge of Selling Premium Products Online",
            content:
              "Selling lifestyle-defining accessories like watches and sunglasses in the premium segment requires more than a store—it demands a platform that mirrors luxury and builds trust from the first click. Twelve-KS needed a site that could support this goal visually and operationally.",
          },
          {
            title: "The Limitations of Generic Themes",
            content:
              "Off-the-shelf WordPress themes often fall short for premium brands. They lack uniqueness, create friction on mobile, and require developers for simple updates. For Twelve-KS, these limitations risked diluting their brand experience and operational agility.",
          },
          {
            title:
              "Introducing Twelve-KS: A Luxury Distributor with Ambitious Visions",
            content:
              "As the exclusive distributor for brands like Meller, Pierre Lannier, and Belvoir&Co, Twelve-KS targeted both Kosovo and European markets. Their goals: communicate luxury, empower their team to manage content, and provide a mobile-first experience that converts.",
          },
          {
            title: "Why Off-the-Shelf Themes Were Insufficient",
            content:
              "Twelve-KS quickly realized generic themes couldn’t match their needs. They lacked brand alignment, flexible product logic, and a maintainable admin interface. For a brand that leads with excellence, these were critical shortcomings.",
          },
          {
            title:
              "The Custom Solution: WordPress + WooCommerce + Tailored Theme",
            content:
              "We built a custom WordPress theme from scratch, integrating WooCommerce for robust ecommerce capabilities. This gave Twelve-KS a site that was polished, high-performing, and designed specifically for their product and brand strategy.",
          },
          {
            title: "Crafting a Brand-First Homepage",
            content:
              "The homepage acts as a digital flagship. We designed it with bold hero banners, featured seasonal collections, and a spacious, elegant layout. The experience reinforces brand confidence and luxury appeal at every scroll.",
          },
          {
            title: "Smart Product Architecture for Lifestyle Categories",
            content:
              "Products were structured into intuitive categories like sunglasses and watches, supported by visual hierarchy, stock indicators, and dynamic filtering. The architecture reflects how users browse—not how inventory is stored.",
          },
          {
            title: "UX Enhancements That Boosted Conversions",
            content:
              "The UI/UX was tuned for clarity and trust. Sticky CTAs, touch-friendly swiping, fast-loading galleries, and dedicated brand sections (like 'Official MELLER Distributor') added legitimacy and increased conversions.",
          },
          {
            title: "Empowering the Team with a Custom CMS",
            content:
              "The backend was built for autonomy. Staff can upload products, run sales, and manage inventory in real time—no devs required. This dramatically reduced campaign launch times and ongoing costs.",
          },
          {
            title: "Mobile Optimization and Performance Tuning",
            content:
              "Given high mobile traffic, we optimized for speed and responsiveness. From streamlined menus to frictionless checkout, every mobile interaction was engineered to be smooth—even on slow connections.",
          },
          {
            title: "WooCommerce Fine-Tuning for Reliability and Speed",
            content:
              "We layered caching, removed plugin bloat, and implemented stable product variation logic for a clean, stable shopping experience. The result: a store that’s scalable and future-proof.",
          },
          {
            title: "Launch Results: Immediate Wins After Go-Live",
            content:
              "Within weeks, Twelve-KS experienced higher mobile engagement, longer session times, reduced bounce rates, and better conversion performance. The site looked premium—and it delivered premium results.",
          },
          {
            title: "Why This Build Model Works for Modern Online Retailers",
            content:
              "A custom WordPress + WooCommerce setup gives lifestyle brands the design control they need with the operational flexibility they want. It’s fast to run, easy to scale, and tailored to how modern ecommerce works.",
          },
          {
            title:
              "Conclusion: Building an Online Store That Reflects Your Brand's Value",
            content:
              "Templates are fine—until you're ready to scale. Twelve-KS chose to invest in a premium, custom solution that reflects their brand, empowers their team, and drives growth. If your store is your brand, this is the right foundation.",
          },
        ],
        images: [
          {
            src: "/projects-pictures/twelve1.png",
            caption:
              "Twelve-KS Custom Homepage Featuring Hero Banners and Collections",
          },
          {
            src: "/projects-pictures/twelve2.png",
            caption:
              "Tailored Product Category Architecture for Premium Accessories",
          },
        ],
      },
    },

    {
      id: 4,
      title:
        "Real-Time Inventory & B2B Order Management: The Future of Scalable Sales Infrastructure",
      description:
        "A custom full-stack B2B platform that unifies inventory, streamlines bulk orders, and connects to Amazon and third-party channels—empowering sales teams with real-time visibility and zero bottlenecks.",
      imageSrc: "/projects-pictures/jblHero.jpg",
      category: "SAAS / B2B",
      date: "07.23.2025",
      author: "Arnit Gashi",
      heroImage: "/projects-pictures/jblHero.jpg",
      content: {
        paragraphs: [
          {
            title: "The Problem: Disconnected Systems and Manual B2B Sales",
            content:
              "Sound Effect, a music gear distributor, struggled with legacy workflows while managing bulk orders across platforms like Amazon and internal CRMs. Inventory lived in spreadsheets, pricing updates were manual, and sales reps juggled tools to serve verified business clients—resulting in overselling, miscommunication, and lost time.",
          },
          {
            title:
              "The Solution: Full-Stack Real-Time Inventory & Order Management",
            content:
              "To solve these bottlenecks, we built a custom platform using Node.js, React, TypeScript, and REST APIs. At its core is a real-time inventory dashboard pulling live stock and pricing data. Sales reps can configure products, assign custom pricing, set promo logic, and push updates to multiple platforms instantly—including Amazon and private B2B portals. A secure, verified B2B portal enables business customers to place large orders, see negotiated pricing, and trigger automated warehouse actions without manual intervention.",
          },
          {
            title:
              "The Outcome: Time Saved, Errors Reduced, and Sales Empowered",
            content:
              "Post-deployment, Sound Effect eliminated overselling, doubled operational speed, and gave sales reps full autonomy. With centralized control, real-time sync, and API flexibility, the system scales effortlessly—whether adding new channels or onboarding new clients. This isn’t a generic ERP—it's a future-ready B2B infrastructure tailored for growth.",
          },
        ],
        images: [
          // {
          //   "src": "/projects-pictures/jblHero.jpg",
          //   "caption": "Sound Effect - Real-Time Inventory Dashboard"
          // },
          // // {
          //   "src": "/jblHero.jpg",
          //   "caption": "Custom B2B Portal with Bulk Order and Pricing Control"
          // }
        ],
      },
    },
    {
      id: 5,
      title:
        "How BeliTravel Took Flight with Soloop: From Travel Dream to Scalable Booking Platform",
      description:
        "We helped BeliTravel transform a vision into a live booking platform—built for Balkan adventures, optimized for mobile, and powered by a custom full-stack solution supporting vendors and travelers alike.",
      imageSrc: "/projects-pictures/beliHero.jpg",
      category: "PLATFORM BUILD",
      date: "07.23.2025",
      author: "Arnit Gashi",
      heroImage: "/projects-pictures/beliHero.jpg",
      logo: {
        src: "/project-logos/beli.png",
        marginTop: 90,
      },
      content: {
        paragraphs: [
          {
            title: "The Challenge: Vision Without a Tech Team",
            content:
              "BeliTravel wanted to build a digital hub for Balkan tourism—offering curated local experiences bookable directly through a unified platform. But they were blocked by limited tech resources, clunky off-the-shelf tools, and booking requirements that no website builder could handle. They needed a custom, mobile-first solution—and a partner to bring it to life.",
          },
          {
            title: "The Solution: A Full-Stack Platform Built from Scratch",
            content:
              "We led a rapid discovery sprint to define goals and mapped user journeys. Then we built a responsive frontend using React, TypeScript, and TailwindCSS, paired with a Node.js + MongoDB backend. Features included a real-time booking engine, vendor dashboards, and an admin panel with full control. Role-based access, email automation, and scalable modular design made it founder-friendly and future-ready.",
          },
          {
            title: "The Results: From MVP to Real Bookings in Weeks",
            content:
              "Within 3 weeks, BeliTravel went live. First bookings came within 48 hours. Over 40 experiences were listed in 3 countries within the first month. The platform scaled easily, handled mobile traffic seamlessly, and gave the founders full control without writing code. This wasn’t just tech—it was operational freedom for a non-technical team with a bold vision.",
          },
        ],
        images: [
          {
            src: "/projects-pictures/beli1.png",
            caption: "BeliTravel - Mobile-Friendly Booking & Vendor Platform",
          },
          {
            src: "/projects-pictures/beli2.png",
            caption:
              "Vendor Dashboard with Listing Control and Availability Management",
          },
        ],
      },
    },
  ],
};
export const getCaseProjectById = (id: number): CaseProject | undefined => {
  return CASES_CONTENT.caseProjects.find((project) => project.id === id);
};
